import { StrategyActionsContext, useCreateStrategyActionsContext } from './StrategyActions.context'
import { CreateStrategyDialog } from './dialogs/CreateStrategyDialog'
import { UpdateStrategyDialog } from './dialogs/UpdateStrategyDialog'

export const StrategyActionsProvider = ({ children }: React.PropsWithChildren) => {
  const context = useCreateStrategyActionsContext()
  const state = context.actionState

  return (
    <StrategyActionsContext.Provider value={context}>
      {children}
      {state?.type === 'create' && <CreateStrategyDialog key="create" onClose={context.close} />}
      {state?.type === 'update' && (
        <UpdateStrategyDialog key={state.params.strategy_id} strategy={state.params} onClose={context.close} />
      )}
    </StrategyActionsContext.Provider>
  )
}
